module.exports = __webpack_public_path__ + "img/no_data.1a7e40bf.svg";